import { http } from '@/core/api/';

const apiUrl = 'api/academicprogress';
export default {
  async sendAcademicProgress(peiId) {
    return await http.get(`${apiUrl}/sendacademicprogress?peiId=${peiId}`);
  },
};
